var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("pleaseChoose")
                  },
                  on: { change: _vm.Renewal },
                  model: {
                    value: _vm.paramsData.is_prod,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "is_prod", $$v)
                    },
                    expression: "paramsData.is_prod"
                  }
                },
                _vm._l(_vm.severlist, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 16 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.sendEmail.open()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("addDraft")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.batchEmail.open()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("batchUpload")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", disabled: !_vm.selsString },
                  on: {
                    click: function($event) {
                      return _vm.handleDelete(_vm.selsString)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("batchDelete")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function() {
                      _vm.tableData = []
                      _vm.getList(_vm.paramsData.page)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("refresh")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.tableData, border: "" },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "id",
              type: "selection",
              selectable: function(row) {
                return row.status == 2 && row.is_item_recycle == 2
              },
              label: _vm.$t("idLabel"),
              width: "50"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "admin_name", label: _vm.$t("operator") }
          }),
          _c("el-table-column", {
            attrs: { prop: "target", label: _vm.$t("type") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.player_type == "all_role"
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("allPlayers")))])
                      : _vm._e(),
                    row.player_type == "online_role"
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("onlinePlayers")))])
                      : _vm._e(),
                    row.player_type == "list_role"
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("selectedPlayers")))])
                      : _vm._e(),
                    row.player_type == "limit"
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("conditionList")))])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "server_name",
              label: _vm.$t("serverName"),
              "show-overflow-tooltip": "",
              "min-width": "160"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "text-ellipsis-1 " }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            row.server_name
                              ? row.server_name.substring(
                                  0,
                                  row.server_name.length - 1
                                )
                              : "/"
                          ) +
                          " "
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "args",
              "show-overflow-tooltip": "",
              label: _vm.$t("condition")
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.player_type !== "limit"
                      ? _c("div", [_vm._v("/")])
                      : _c(
                          "div",
                          {
                            staticClass: "text-cursor",
                            staticStyle: { color: "#409EFF" },
                            on: {
                              click: function($event) {
                                return _vm.$refs.limitDetails.init(row)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("view")))]
                        )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "args",
              "show-overflow-tooltip": "",
              label: _vm.$t("playerId")
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.args.toString() == "0" || !row.args.length
                      ? _c("div", [_vm._v("/")])
                      : _c(
                          "div",
                          {
                            staticClass: "text-cursor",
                            staticStyle: { color: "#409EFF" },
                            on: {
                              click: function($event) {
                                return _vm.$refs.idDetails.init(row.args)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("view")))]
                        )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "reward", label: _vm.$t("item") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.reward.length
                      ? _c(
                          "div",
                          {
                            staticClass: "text-cursor",
                            staticStyle: { color: "#409EFF" },
                            on: {
                              click: function($event) {
                                return _vm.$refs.viewArticles.init(
                                  row.reward,
                                  "Articles"
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("view")))]
                        )
                      : _c("div", [_vm._v("/")])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "request_data", label: _vm.$t("contentDetails") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "text-cursor",
                        staticStyle: { color: "#409EFF" },
                        on: {
                          click: function($event) {
                            return _vm.$refs.contentView.open(
                              row.content_Val,
                              "Articles"
                            )
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("view")))]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "is_delay",
              label: _vm.$t("scheduledSend"),
              "min-width": "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(row.is_delay == 1 ? row.delay_time : "/") +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "status", label: _vm.$t("status") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      { style: { color: row.status == 1 ? "#409EFF" : "" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              row.status == 1
                                ? _vm.$t("sent")
                                : _vm.$t("notSent")
                            ) +
                            " "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "created_at",
              label: _vm.$t("addTime"),
              "min-width": "180"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operation"),
              width: "200",
              fixed: _vm.isMobile ? false : "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          staticStyle: { "margin-right": "10px" },
                          on: {
                            click: function($event) {
                              return _vm.$refs.addEmailcopy.open(row)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("copy")))]
                      ),
                      row.status == 2
                        ? _c("div", { staticClass: "x-c" }, [
                            _c(
                              "div",
                              {
                                staticClass: "controlsBtn",
                                on: {
                                  click: function($event) {
                                    return _vm.$refs.sendEmail.open(row)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("edit")))]
                            ),
                            row.is_delay == 2
                              ? _c("div", {
                                  staticClass: "controlsBtn-vertical"
                                })
                              : _vm._e(),
                            row.is_delay == 2
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "controlsBtn",
                                    on: {
                                      click: function($event) {
                                        return _vm.sendEmails(row.id)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("send")))]
                                )
                              : _vm._e(),
                            row.is_item_recycle == 2
                              ? _c("div", {
                                  staticClass: "controlsBtn-vertical"
                                })
                              : _vm._e(),
                            row.is_item_recycle == 2
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "controlsBtn",
                                    on: {
                                      click: function($event) {
                                        _vm.handleDelete(JSON.stringify(row.id))
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("delete")))]
                                )
                              : _vm._e()
                          ])
                        : _vm._e()
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          layout: "total,sizes, prev, pager, next",
          "current-page": _vm.paramsData.page,
          total: _vm.total,
          page_size: _vm.paramsData.page_size
        },
        on: { "current-change": _vm.getList, "size-change": _vm.sizeChange }
      }),
      _c("addEmail", {
        ref: "sendEmail",
        attrs: {
          serverList: _vm.serverMergeList,
          channellAllList: _vm.channelList,
          prod: { is_prod: _vm.paramsData.is_prod }
        },
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      }),
      _c("viewArticles", {
        ref: "viewArticles",
        attrs: { prod: { is_prod: _vm.paramsData.is_prod } }
      }),
      _c("contentView", { ref: "contentView" }),
      _c("idDetails", { ref: "idDetails" }),
      _c("limitDetails", {
        ref: "limitDetails",
        attrs: { channellAllList: _vm.channelList }
      }),
      _c("batchEmail", {
        ref: "batchEmail",
        attrs: { paramsData: { is_prod: _vm.paramsData.is_prod } },
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      }),
      _c("addEmailcopy", {
        ref: "addEmailcopy",
        attrs: {
          serverList: _vm.serverMergeList,
          channellAllList: _vm.channelList,
          prod: { is_prod: _vm.paramsData.is_prod }
        },
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }